export default "__VITE_ASSET__OXSAf$$S__"